<div id="page" class="site">
  <!-- *ngIf="IsMobile" -->
  <header  id="MobileHeader-wrapper">
    <div class="col-sm-12 col-md-12 col-xs-12">
      <div class="row">
        <div class="col-6">
          <a routerLink='/mfmain/home'>
            <img [src]="CompanyLogo" style="height:48px; padding:5px 2px 2px;" />
          </a>
        </div>
        <div class="col-6">
          <div class="mainDivhamberger">
            <div class="openNav"><img src="../../assets/images/img/sidenav-icon.svg" /></div>
          </div>
          <div id="mySidenav" class="sidenav">
            <a href="javascript:void(0)" class="closebtn closeNav">&times;</a>
            <a routerLink="/login/investor">
              <div class="mt-2fr3  sb-primary-cta-button CstBtn large-btn schedule-a-call trigger-event schedule-a-call-js w-100"
                data-action="schedule a call-Plan" data-category="offering-Plan" data-label="planning section">
                Login
              </div>
            </a>
            <a class="mt-2 mb-1" routerLink="/client-preOnboading">
              <div class='sb-secondary-cta-button trigger-event unset-transform mbfw'
                data-action='Web Home schedule a call' data-category='conversion' data-label='Schedule a Call'
                data-properties='{&quot;action&quot;: &quot;Web Home schedule a call&quot;}'>
                SIGN UP
              </div>
            </a>
            <div class="accordion_container accordianenuContainer">
              <div class='col-sm-12 col-md-12 col-xs-12 nopadding'>
                <div class="accordion_head menuaccordian"> <span class="contentDiv">Explore Mutual Funds</span><span
                    class="plusminus contentDec">-</span></div>
                <div class="accordion_body Maincontentbody p-2" style="display: none !important;">
                  <a routerLink="/mf/Types_Of_MF"  class="mt-1">Types of Mutual Funds</a>
                  <a routerLink="/mf/Advantages_Of_MutualFundsComponent">Advantages of MF</a>
                  <a routerLink="/mf/categorization-of-mutual-funds">Categorisation of MFs</a>
                  <a routerLink="/mf/FAQ">Myths & Facts about MF</a>
                  <a routerLink="/mf/FAQ">Frequently Asked Questions</a>
                </div>
              </div>
            </div>

            <a routerLink="/mfmain/home">Home</a>
            <a routerLink="/mf/About">About Us</a>

            <a href="#">Platform Features</a>
            <a routerLink="/mf/MarketViews">Market Views</a>
            <a routerLink="/mf/Wealth_Calculators">Wealth Calculators</a>
            <a routerLink="/mf/Reviews">Investor Reviews</a>
            <a routerLink="/mf/Contact">Contact Us</a>
            <!--<a class="divider"></a>

             <a href="#">Social Connect</a>
            <ul class="socialLinks-list SociallinkMobile">
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="twitter">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/Google_Colorful.svg" alt="twitter">
                </a>
              </li>
              <li>
                <a href="#" target="_self"
                  rel="nofollow noopener" title="youtube">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/youtube-icon.svg" alt="youtube">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="twitter">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/WhatsApp_Color.svg" alt="twitter">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener" title="Telegram">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/telegram-icon.svg"
                    alt="telegram">
                </a>
              </li>
              <li>
                <a href="#" target="_self"
                  rel="nofollow noopener" title="linkedin">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/linkedin-icon.svg"
                    alt="linkedin">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="facebook">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/facebook-icon.svg"
                    alt="facebook">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="twitter">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/twitter-icon.svg" alt="twitter">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="instagram">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/instagram.svg" alt="instagram">
                </a>
              </li>







            </ul> -->
            <a class="divider"></a>
            <a routerLink='/login' routerLinkActive='active'>MFD Admin Login</a>

          </div>
          <div class="sidebar-mask"></div>
          <!-- Use any element to open the sidenav -->


        </div>
      </div>
    </div>


  </header>
  <header id="header-mega-menu-wrapper" class="top-0 z-50 w-full bg-white  site-header header-fixed ">
    <div class=" relative containerPadding  bg-white">
      <nav class="flex items-center lg:flex-wrap navbar customnavigation">
        <div class="flex items-center nav-brand order-1 py-2 ml-auto lg:ml-0 lg:order-4">

          <a (click)="modalPopOpen()" class="px-2 py-2 headerClicktext"><span class="fa fa-phone mx-1"></span>
            SCHEDULE CALL</a>
            <div class="downloadApp-block">
          <a class="px-3 py-2 btncommon btn mx-2 btnCommonGray" (click)="OpenModalForAppQR()" ><span class="fa fa-mobile mr-1"></span> DOWNLOAD APP </a>
           
          </div>

          <a href="client-preOnboading" target="_self" class="px-3 py-2 btncommon btn mx-2 btnCommonSecondary wdth100"> SIGN UP </a>
          <!--comment by adarsh 221112023 <a href="login/investor" target="_self" class="px-3 py-2 btncommon btn mx-2 btnCommonPrimary wdth100">LOGIN</a> -->
         <!-- added by adarsh 22112023 -->
         <a  style="cursor: context-menu;">
          <div  class="px-3 py-2 btncommon btn mx-2 btnCommonPrimary wdth100"
            routerLink='/login/investor' routerLinkActive='active'>
            LOGIN
          </div>
        </a>

         <!-- till here -->

          <div class="mainDivhamberger desktop-hamberger">
            <div class="openNav"><img src="../../assets/images/img/sidenav-icon.svg" /></div>
          </div>
          <div id="mySidenavDesktop" class="sidenav">
            <a href="javascript:void(0)" class="closebtn closeNav">&times;</a>
            <a  style="cursor: context-menu;">
              <div class="mt-2fr3  sb-primary-cta-button CstBtn large-btn w-100 schedule-a-call trigger-event schedule-a-call-js"
                data-action="schedule a call-Plan" data-category="offering-Plan" data-label="planning section" routerLink='/login/investor' routerLinkActive='active'>
                Login
              </div>
            </a>
            <a class="mt-2 mb-1" href="client-preOnboading">
              <div class='sb-secondary-cta-button trigger-event unset-transform fw w-100'
                data-action='Web Home schedule a call' data-category='conversion' data-label='Schedule a Call'
                data-properties='{&quot;action&quot;: &quot;Web Home schedule a call&quot;}'>
                SIGN UP
              </div>
            </a>
            <div class="accordion_container accordianenuContainer">
              <div class='col-sm-12 col-md-12 col-xs-12 nopadding'>
                <div class="accordion_head menuaccordian"> <span class="contentDiv">Explore Mutual Funds</span><span
                    class="plusminus contentDec">+</span></div>
                <div class="accordion_body Maincontentbody p-2 px-3" style="display: none !important;">
                  <a routerLink="/mf/Types_Of_MF" class="mt-1">Types of Mutual Funds</a>
                  <a routerLink="/mf/Advantages_Of_MutualFundsComponent">Advantages of MF</a>
                  <a routerLink="/mf/categorization-of-mutual-funds">Categorisation of MFs</a>
                  <a routerLink="/mf/FAQ">Myths & Facts about MF</a>
                  <a routerLink="/mf/FAQ">Frequently Asked Questions</a>
                </div>
              </div>
            </div>

            <a routerLink="/mfmain/home">Home</a>
            <a routerLink="/mf/About">About Us</a>

            <a href="/mfmain/home/#platformfeatures">Features</a>
            <a routerLink="/mf/MarketViews">Market Views</a>
            <a routerLink="/mf/Wealth_Calculators">Calculators</a>
            <a routerLink="/mf/Reviews">Investor Reviews</a>
            <a routerLink="/mf/Contact">Contact Us</a>
            <!--<a class="divider"></a>
             <a href="#">Social Connect</a>
            <ul class="socialLinks-list SociallinkMobile">
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="twitter">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/Google_Colorful.svg" alt="twitter">
                </a>
              </li>
              <li>
                <a href="#" target="_self"
                  rel="nofollow noopener" title="youtube">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/youtube-icon.svg" alt="youtube">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="twitter">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/WhatsApp_Color.svg" alt="twitter">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener" title="Telegram">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/telegram-icon.svg"
                    alt="telegram">
                </a>
              </li>
              <li>
                <a href="#" target="_self"
                  rel="nofollow noopener" title="linkedin">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/linkedin-icon.svg"
                    alt="linkedin">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="facebook">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/facebook-icon.svg"
                    alt="facebook">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="twitter">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/twitter-icon.svg" alt="twitter">
                </a>
              </li>
              <li>
                <a href="#" target="_self" rel="nofollow noopener"
                  title="instagram">
                  <img width="22" height="22" class="icon scaleAnimation"
                    src="../../assets/images/img/socialicons/instagram.svg" alt="instagram">
                </a>
              </li>







            </ul> -->
            <a class="divider"></a>
            <a routerLink='/login' routerLinkActive='active'>MFD Admin Login</a>
          </div>
          <div class="sidebar-mask"></div>

        </div>
        <div class="flex items-center  nav-brand  lg:order-3 lg:mx-auto">
          <figure class="z-20 overflow-hidden bg-white">
            <a  routerLink='/mfmain/home'>
              <img [src]="CompanyLogo" style="height:68px" />
            </a>
          </figure>
        </div>

        <div class="duration-200 ease-in flex header-flag items-center lg:order-2 sm:ml-0 transition-all">

        </div>

        <div class="z-10 nav-items bg-white lg:hidden lg:order-2 lg:w-full ml-7 lg:ml-0">
          <div id="header-mega-menu" class="menu-style">

          </div>
        </div>
        <div class="hidden lg:block flex items-center lg:order-1 md:flex-row-reverse md:ml-0 relative search-control">

        </div>
      </nav>
    </div>
  </header>
  <div class="secondary-header" style="height: 33px; top: 1px;" style="display: none;">
    <div id="secondary-menu-wrapper" class="z-40 secondary-menu-wrapper w-full bg-white ">
      <div class="containerPaddingSecondary flex">

        <div class="relative secondary-header secondary-menu-nav-items sm:px-0 w-full overflow-scroll mr-14 md:mr-0">
          <div id="plan-secondary-header-menu" class="secondary-header-style">
            <ul id="plan-secondary-header-menu"
              class="secondary-header__list flex justify-end w-100 flex-no-wrap overflow-x-scroll justify-start">
              <li id="menu-item-75111" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75111">
                <a href="#">Home</a>
              </li>
              <li id="menu-item-75112" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75112">
                <a href="#">About
                  Us</a>
              </li>
              <li id="menu-item-75113" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75113">
                <a href="#">Mutual
                  Funds</a>
              </li>
              <li id="menu-item-75114" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75114">
                <a href="#">Features</a>
              </li>
              <li id="menu-item-75115" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75115">
                <a href="#">Market
                  Views</a>
              </li>
              <li id="menu-item-75116" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75116">
                <a href="#">Calculators</a>
              </li>
              <li id="menu-item-75117" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75116">
                <a href="#">Contact
                  Us</a>
              </li>

              <form style="display: none;">
                <div class="row">
                  <div class="col-sm-4 col-md-3 col-xs-12">
                    <div class="col_full box">

                      <!-- <i class="fa fa-user" aria-hidden="true"></i>-->
                      <input name="txtUserName" type="text" id="txtUserName" tabindex="1" class=" form-control not-dark"
                        placeholder="UserName" style="border: 1px solid red;">
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-3 col-xs-12">
                    <div class="col_full">

                      <input name="txtPassword" type="password" id="txtPassword" tabindex="2"
                        class="form-control not-dark" autocomplete="off" placeholder="Password"
                        style="border: 1px solid red;">
                      <!-- <i class="" aria-hidden="true">Forgot?</i>-->

                    </div>

                  </div>
                  <div class="col-sm-4 col-md-3 col-xs-12">
                    <div class="center MarginTop20" style="margin-bottom: 5px;">
                      <input type="submit" name="LoginButton" value="Submit" id="LoginButton" tabindex="3"
                        class="inline-block px-3 py-2 text-sm font-semibold leading-4 text-white transition duration-200 ease-in bg-orange-400 hover:bg-orange-600 rounded-md shadow-lg lg:hidden">

                      <span class="breakLine"></span>
                    </div>
                  </div>

                </div>


              </form>

            </ul>
          </div>
          <!-- <span class="secondary-header__overlay"></span>
          <span class="secondary-header__mobile-background-overlay"></span> -->
        </div>

      </div>
    </div>
  </div>
  <div class="secondary-header d-none" style="height: 33px; top: 1px;">
    <div id="secondary-menu-wrapper" class="z-40 secondary-menu-wrapper w-full bg-white ">
      <div class="containerPaddingSecondary flex">

        <div class="relative secondary-header secondary-menu-nav-items sm:px-0 w-full overflow-scroll mr-14 md:mr-0">
          <div id="plan-secondary-header-menu" class="secondary-header-style">
            <ul id="plan-secondary-header-menu"
              class="secondary-header__list flex justify-end w-100 flex-no-wrap overflow-x-scroll justify-start">

              <li id="menu-item-75111" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75111">
                <a href="#"><span class="fa fa-envelope mx-2 socialicond"></span>sales@optimufvintech.com</a>
              </li>
              <li id="menu-item-75112" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75112">
                <a href="#"><span class="fa fa-phone mx-2 socialicond"></span>+91 9898989898</a>
              </li>
              <li id="menu-item-75113" class="menulicontentSocial ml-4 menu-item menu-item-type-custom menu-item-object-custom menu-item-75113">
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/whatsapp.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/telegram-plane.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/Instagram_1.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/twitter.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/facebook-f.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/linkedin.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/youtube.svg" class="svg"/></span></a>
                <a href="#"><span class="socialicond"><img src="../../assets/images/img/socialicons/google.svg" class="svg"/></span></a>


              </li>




            </ul>
          </div>

        </div>

      </div>
    </div>
  </div>


  <!-- fixed navigation bar -->
  <section id="bottomnav">
    <div class="container">
      <div class="topContent BGConatainerSection">
        <div class="col-sm-12 col-md-12 col-xs-12 nopadding">
          <div class="xtra-fixed-mobile-nav xtra-fixed-mobile-nav-title-column">
            <a routerLink='/mfmain/home' routerLinkActive='active' title="Home"><img
                src="../../../assets/images/img/bottom/HomeIcon.svg" class="svg"><span>Home</span></a>
            <a routerLink='/mf/MobileMutualFund' routerLinkActive='active' title="Mutual fund"><img
                src="../../../assets/images/img/bottom/MutualFunds_1.svg" class="svg"><span>Mutual Funds</span></a>
            <a routerLink='/mf/MarketViews' routerLinkActive='active' title="Market Views"><img
                src="../../../assets/images/img/bottom/marketviewsnew.svg" class="svg marketviews"><span>Market
                Views</span></a>
            <a routerLink='/mf/About' routerLinkActive='active' title="Contact"><img
                src="../../../assets/images/img/bottom/About-new.svg" class="svg"><span>About Us</span></a>
            <a routerLink='/mf/Wealth_Calculators' routerLinkActive='active' title="Wealth calculators" ><img
                src="../../../assets/images/img/bottom/carbon_calculator.svg" class="svg "><span>Calculators</span></a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div aria-hidden='true' aria-labelledby='LetsTalk_popup' class='modal fade' data-keyboard='false'
  id='LetsTalk_popup' tabindex='-1'>
  <div class='modal-dialog modal-dialog-centered border-0'>
    <div class='modal-content border-0 p-0'>
      <div class='modal-header border-0 p-0 ltmodalheader'>

        <button aria-label='Close' class='close CloseMob_Pre' data-dismiss='modal' type='button'>
          <span aria-hidden='true'>×</span>
        </button>
      </div>
      <div class='modal-body border-0 p-10 pt-0 mobilep-2'>
        <form [formGroup]="LetsTalkForm" (ngSubmit)="onsubmitLetsTalkForm()">
          <div class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
            <div class='align-self-center'>
              <h2 class='wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth BlackTxt'>
                Let's Talk
              </h2>

              <p class='wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10'>
               Let's connect on a quick call to understand better.
              </p>


            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-xs-12 mobilemt-20">
                <div class="call-plan-form-group call-plan-form-group-name">

                  <input formControlName="customer_name" class="form-control" id="customer_name" maxlength="30" placeholder="Full Name"
                    name="customer-name" type="text" required>
                  <label for="customer-name"></label>
                  <span class="d-none customer-name-error" style="color: red">
                    Please enter your name
                  </span>
                </div>
              </div>
              <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                        <div class="call-plan-form-group call-plan-form-group-name">

                          <input class="form-control" id="customer_name" placeholder="last name"
                            maxlength="30" name="customer-name" required="" type="text">
                          <label for="customer-name"></label>
                          <span class="d-none customer-name-error" style="color: red">
                            Please enter your name
                          </span>
                        </div>
                      </div> -->
            </div>
            <div class="row">
              <div class="col-sm-6 col-md-6 col-xs-6">
                <div class="call-plan-form-group call-plan-form-group-name">

                  <input class="form-control" formControlName="Mobile_No" id="Mobile_No" maxlength="30" placeholder="Mobile"
                    name="Mobile_No" required type="number">
                  <label for="Mobile_No"></label>
                  <div *ngIf="f.Mobile_No.touched && f.Mobile_No.invalid">
                  <span *ngIf="f.Mobile_No.errors.required" class="d-none Mobile_No-error" style="color: red">
                    Mobile Number is required.
                  </span>
                  <span *ngIf="f.Mobile_No.errors.pattern" class="d-none Mobile_No-error" style="color: red">
                    Please, Enter 10 digit Mobile Number.
                  </span>
                </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-6">
                <div class="call-plan-form-group call-plan-form-group-name">

                  <input class="form-control" formControlName="customer_Email" id="customer_Email" placeholder="Email" maxlength="70"
                    name="customer_Email" required type="text">
                  <label for="customer_Email"></label>
                  <span class="d-none customer_Email-error" style="color: red">
                    Please enter your email id
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-md-6 col-xs-6">
                <div class="call-plan-form-group call-plan-form-group-name">

                  <!-- <select class="form-control">
                    <option>State</option>
                  </select> -->
                  <input class="form-control" formControlName="Statein" id="Statein" placeholder="State" maxlength="30"
                    name="Statein" required type="text">
                  <label for="Statein"></label>
                  <span class="d-none Statein-error" style="color: red">
                    Please enter state
                  </span>


                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-6">
                <div class="call-plan-form-group call-plan-form-group-name">

                  <input class="form-control" formControlName="city_name" id="city_name" maxlength="30" placeholder="City"
                    name="city_name" required type="text">
                  <label for="city_name"></label>
                  <span class="d-none city_name-error" style="color: red">
                    Please enter city name
                  </span>
                </div>
              </div>

            </div>
            <div class="row">

              <div class="col-sm-12 col-md-12 col-xs-6">
                <div class="call-plan-form-group call-plan-form-group-name">

                  <input class="form-control" formControlName="customer_Meassage" id="customer_Meassage" maxlength="30" placeholder="Message"
                    name="customer_Meassage" required type="text">
                  <label for="customer_Meassage"></label>
                  <span class="d-none customer_Meassage-error" style="color: red">
                    Please enter some Message
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="call-plan-form-group">
                  <label class="form-label">
                    Preferred time to talk:
                  </label>
                </div>
                <div class="btn-group btn-group-toggle select-call-time select-call-time-js"
                  data-toggle="buttons">
                  <label class="btn btn-outline-sb-green option-1 active">
                    <input data-max="12" data-min="8" id="option1" name="talk_schedule1" type="radio"
                      value="10am - 12pm" formControlName="talk_schedule1" (click)="Scheduletimecall($event)">

                    10 - 12
                  </label>
                  <label class="btn btn-outline-sb-green option-2">
                    <input data-max="16" data-min="12" id="option2" name="talk_schedule1" type="radio"
                      value="12pm - 2pm" formControlName="talk_schedule1" (click)="Scheduletimecall($event)">

                    12 - 2
                  </label>
                  <label class="btn btn-outline-sb-green option-3">
                    <input data-max="20" data-min="16" id="option3" name="talk_schedule1" type="radio"
                      value="2pm - 4pm" formControlName="talk_schedule1" (click)="Scheduletimecall($event)">

                    2 - 4
                  </label>
                  <label class="btn btn-outline-sb-green option-3">
                    <input data-max="20" data-min="16" id="option3" name="talk_schedule1" type="radio"
                      value="4pm - 6pm" formControlName="talk_schedule1" (click)="Scheduletimecall($event)">

                    4 - 6
                  </label>
                  <label class="btn btn-outline-sb-green option-3">
                    <input data-max="20" data-min="16" id="option3" name="talk_schedule1" type="radio"
                      value="6pm - 8pm" formControlName="talk_schedule1" (click)="Scheduletimecall($event)">

                    6 - 8
                  </label>
                </div>
              </div>
            </div>
            <div class="row">

              <div class="col-md-12">
                <div class="call-plan-form-group pb-3 text-center mt-30 mobilemt-0 mobilemb-20">
                  <div
                    class="mt-3 sb-primary-cta-button large-btn  schedule-a-call trigger-event schedule-a-call-js"
                    data-action="schedule a call-Plan" data-category="offering-Plan"
                    data-label="planning section"><button type="submit"> <!-- [disabled]="!LetsTalkForm.valid"-->
                    Call Me</button>
                  </div>
                  <a href="mf/MobileMutualFund" style="font-size:10px;" target="_self"
                    class="anchorColor desktopHide"> Click here to know more about
                    Mutual
                    Funds first</a>
                </div>
              </div>


            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

  <!-- end-->

</div>

